
import React from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';

// Admin pages
import Dashboard from '@/pages/admin/Dashboard';
import BikesPage from '@/pages/admin/BikesPage';
import CouriersPage from '@/pages/admin/CouriersPage';
import RentalsPage from '@/pages/admin/RentalsPage';
import LocationHistoryPage from '@/pages/admin/LocationHistoryPage';
import AnalyticsPage from '@/pages/admin/AnalyticsPage';
import SettingsPage from '@/pages/admin/SettingsPage';
import PaymentsPage from '@/pages/admin/payments/PaymentsPage';
import AdminSubscriptionsPage from '@/pages/admin/SubscriptionsPage';
import MileagePage from '@/pages/admin/MileagePage';

/**
 * Компонент, содержащий все маршруты для администратора
 * @param isAdmin - флаг, указывающий, является ли пользователь администратором
 */
export const AdminRoutes: React.FC<{ isAdmin: boolean }> = ({ isAdmin }) => {
  return (
    <>
      <Route path="/admin" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <Dashboard />
        </ProtectedRoute>
      } />

      <Route path="/admin/bikes" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <BikesPage />
        </ProtectedRoute>
      } />

      <Route path="/admin/couriers" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <CouriersPage />
        </ProtectedRoute>
      } />

      <Route path="/admin/rentals" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <RentalsPage />
        </ProtectedRoute>
      } />

      <Route path="/admin/mileage" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <MileagePage />
        </ProtectedRoute>
      } />

      <Route path="/admin/subscriptions" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <AdminSubscriptionsPage />
        </ProtectedRoute>
      } />

      <Route path="/admin/payments" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <PaymentsPage />
        </ProtectedRoute>
      } />

      <Route path="/admin/location-history" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <LocationHistoryPage />
        </ProtectedRoute>
      } />

      <Route path="/admin/analytics" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <AnalyticsPage />
        </ProtectedRoute>
      } />

      <Route path="/admin/settings" element={
        <ProtectedRoute isAllowed={isAdmin} redirectPath="/courier">
          <SettingsPage />
        </ProtectedRoute>
      } />
    </>
  );
};
